import { css } from 'styled-components';

export const defaultShadow = css`
  box-shadow: 0px 1px 2px rgba(77, 77, 77, 0.15),
    0px 40px 60px rgba(77, 77, 77, 0.2);
`;

export const brandShadow = css`
  box-shadow: 0px 1px 2px #5dc66b, 0px 40px 60px rgba(93, 198, 107, 0.15);
`;

export const actionShadow = css`
  box-shadow: 0px 1px 2px rgba(0, 163, 255, 0.15),
    0px 20px 60px rgba(0, 163, 255, 0.75);

  &:hover {
    box-shadow: 0px 1px 2px rgba(0, 163, 255, 0.15),
      0px 5px 10px rgba(0, 163, 255, 0.75);
  }

  &:active {
    box-shadow: none;
    backdrop-filter: blur(40px);
  }
`;

const shadows = {
  defaultShadow,
  brandShadow,
  actionShadow,
};

export default shadows;
